import React from "react";
import { Link } from 'react-router-dom';


const Card03 = ({
    item,
}) => {

    return (
        <>
            <div className="sc-card-product text-left">
                <div className="gig-wrapper">
                    <div className="gig-title-section d-flex">
                        <div className="gig-title-section-image">
                            <img src={item.avatar} alt={item.title} />
                        </div>
                        <div className="gig-title-section-right">
                            <div className="gig-title-section-right-title">
                                {item.title}
                            </div>
                            <div className="gig-title-section-right-created-by">
                                Created by <span>{item.created_by}</span>
                            </div>
                        </div>
                    </div>
                    <div className="gig-description">
                        {item.description}
                    </div>
                </div>
            </div>  
        </>
    )
}

export default Card03;